import { FC } from 'react';
import { DefaultTheme } from 'styled-components';
import BurgundyEngineConfig from '../../config';
import { BurgundyEngineDelegate } from '../../delegate';
import { getPathContext } from './getPathContext';

export interface MiniApplicationManifestAuth {
    productionClientId: string;
    developClientId: string;
    service?: string;
}

/**
 * Манифест мини-приложения
 */
export interface MiniApplicationManifest {
    title?: string;
    reducer?: any;
    auth?: MiniApplicationManifestAuth;
    theme?: DefaultTheme;
    clear?: boolean;
    ssr?: boolean;
}

/**
 * Режим приложения
 */
export type AppNodeMode = 'develop' | 'staging' | 'production';

/**
 * Запись о приложении
 */
export interface AppNode {
    application: string;
    mode: AppNodeMode;
    pathContexts?: string[]
}

export interface RoutingMiniAppData extends AppNode {
    host: string;
    basename?: string
}

export interface AppContent {
    App: FC<{ mode: AppNodeMode }>;
    manifest: MiniApplicationManifest;
}

export function StartRoutingMiniApps(
  manifest: Record<string, AppNode>,
  callback: (miniApp: RoutingMiniAppData | undefined) => void,
): void {
    const location = window.location;
    const host = location.host;
    console.log('StartRoutingMiniApps!!!', host, location, location?.pathname);

    // первый приоритет у приложения для авторизации
    if (BurgundyEngineDelegate.shouldUseAuthenticationApplication(location)) {
        callback({
            host,
            application: BurgundyEngineConfig.loginApplicationName,
            mode: 'production', // авторизация всегда запускается в режиме production
        });
        return;
    }

    // запуск по делегату
    const extraApp = BurgundyEngineDelegate.shouldRunExtraApplication(location);
    if (extraApp && typeof extraApp === 'string') {
        callback({
            host,
            application: extraApp,
            mode: 'develop',
        });
        return;
    }

    const app = getPathContext();
    // Запуск из консоли
    if (host?.includes('localhost:') || host?.includes('bs-local.com:') || host?.includes('192.168.1.44:')) {
        const localStorageData = localStorage.getItem('current-app');
        const miniAppName = localStorageData ?? process.env.REACT_APP_NAME;
        if (miniAppName) {
            callback({
                host,
                application: miniAppName,
                mode: 'develop',
                ...app,
            });
            return;
        }
    }

    // Проверка на наличие хоста в манифесте
    if ((host in manifest) || app?.basename) {
        // console.log('StartRoutingMiniApps', app, host, manifest, process.env.NODE_ENV);
        callback({ host, ...app });
    } else {
        callback(undefined);
    }
}

export interface StarterFunctions {
  beforeStart?: () => Promise<void>;
}
import { FC } from 'react';
import { DefaultTheme } from 'styled-components';
import BurgundyEngineConfig from '../../config';
import { BurgundyEngineDelegate } from '../../delegate';
import { getPathContext } from './getPathContext';

export interface MiniApplicationManifestAuth {
    productionClientId: string;
    developClientId: string;
    service?: string;
}

/**
 * Манифест мини-приложения
 */
export interface MiniApplicationManifest {
    title?: string;
    reducer?: any;
    auth?: MiniApplicationManifestAuth;
    theme?: DefaultTheme;
    clear?: boolean;
    ssr?: boolean;
}

/**
 * Режим приложения
 */
export type AppNodeMode = 'develop' | 'staging' | 'production';

/**
 * Запись о приложении
 */
export interface AppNode {
    application: string;
    mode: AppNodeMode;
    pathContexts?: string[]
}

export interface RoutingMiniAppData extends AppNode {
    host: string;
    basename?: string
}

export interface AppContent {
    App: FC<{ mode: AppNodeMode }>;
    manifest: MiniApplicationManifest;
}

export function StartRoutingMiniApps(
  manifest: Record<string, AppNode>,
  callback: (miniApp: RoutingMiniAppData | undefined) => void,
): void {
    const location = window.location;
    const host = location.host;
    console.log('StartRoutingMiniApps!!!', host, location, location?.pathname);

    // первый приоритет у приложения для авторизации
    if (BurgundyEngineDelegate.shouldUseAuthenticationApplication(location)) {
        callback({
            host,
            application: BurgundyEngineConfig.loginApplicationName,
            mode: 'production', // авторизация всегда запускается в режиме production
        });
        return;
    }

    // запуск по делегату
    const extraApp = BurgundyEngineDelegate.shouldRunExtraApplication(location);
    if (extraApp && typeof extraApp === 'string') {
        callback({
            host,
            application: extraApp,
            mode: 'develop',
        });
        return;
    }

    const app = getPathContext();
    // Запуск из консоли
    if (host?.includes('localhost:') || host?.includes('bs-local.com:') || host?.includes('192.168.1.44:')) {
        const localStorageData = localStorage.getItem('current-app');
        const miniAppName = localStorageData ?? process.env.REACT_APP_NAME;
        if (miniAppName) {
            callback({
                host,
                application: miniAppName,
                mode: 'develop',
                ...app,
            });
            return;
        }
    }

    // Проверка на наличие хоста в манифесте
    if ((host in manifest) || app?.basename) {
        // console.log('StartRoutingMiniApps', app, host, manifest, process.env.NODE_ENV);
        callback({ host, ...app });
    } else {
        callback(undefined);
    }
}

export interface StarterFunctions {
  beforeStart?: () => Promise<void>;
}
